var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnership(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#partnership_svg__clip0_61530_7249)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 6.75a3 3 0 110-6 3 3 0 010 6zm0-4.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM18 6.75a3 3 0 110-6 3 3 0 010 6zm0-4.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM19.5 22.5h-3A1.5 1.5 0 0115 21v-5.25h1.5V21h3v-6.75H21v-4.5a.75.75 0 00-.75-.75h-4.815L12 15 8.565 9H3.75a.75.75 0 00-.75.75v4.5h1.5V21h3v-5.25H9V21a1.5 1.5 0 01-1.5 1.5h-3A1.5 1.5 0 013 21v-5.25a1.5 1.5 0 01-1.5-1.5v-4.5A2.25 2.25 0 013.75 7.5h5.685L12 12l2.565-4.5h5.685a2.25 2.25 0 012.25 2.25v4.5a1.5 1.5 0 01-1.5 1.5V21a1.5 1.5 0 01-1.5 1.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "partnership_svg__clip0_61530_7249"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgPartnership;